export default {
  hero: {
    badge: 'Centro de recursos de USFans Spreadsheet',
    title: 'USFans Spreadsheet — Encuentra productos, vendedores y guías de compra',
    subtitle: 'Explora los recursos de la hoja de cálculo USFans, enlaces de productos, información de vendedores, reseñas, guías de envío, consejos de control de calidad e información práctica de compra en un solo lugar organizado.',
    ctaExplore: 'Explorar USFans Spreadsheet',
    ctaBuy: 'Comprar ahora',
  },
  category: {
    title: 'Explora las categorías de productos',
    subtitle: 'Salta directamente a cualquier categoría del sitio principal con un solo clic.',
    dropdownLabel: 'Selector rápido de categoría',
    dropdownPlaceholder: 'Selecciona una categoría...',
    visit: 'Ver categoría',
    shoes: 'Zapatos',
    hoodies: 'Sudaderas / Suéteres',
    tshirts: 'Camisetas',
    jackets: 'Chaquetas',
    pants: 'Pantalones / Shorts',
    headwear: 'Sombreros y gorras',
    sets: 'Conjuntos',
    underwear: 'Ropa interior / Calzoncillos',
    jersey: 'Camiseta deportiva',
    accessories: 'Accesorios',
    bags: 'Bolsos',
    belts: 'Cinturones',
    perfumes: 'Perfumes',
    other: 'Otras cosas',
  },
  cta: {
    title: 'Empieza con USFans Spreadsheet',
    text: 'Explora los recursos organizados de USFans, reseñas, información de envío y guías de compra prácticas. Dos enlaces rápidos te llevan directo al sitio principal.',
    spread: 'USFans Spreadsheet',
    buyNow: 'Comprar ahora',
  },
  about: {
    title: '¿Qué es una hoja de cálculo USFans?',
    p1: 'Una hoja de cálculo USFans es una forma estructurada de organizar enlaces de productos, información de vendedores, categorías y recursos de compra relacionados en un solo lugar fácil de leer.',
    p2: 'USFansLink ayuda a los usuarios a investigar productos, vendedores, controles de calidad, envíos, información del almacén y consideraciones de seguridad antes de hacer un pedido. Reúne los recursos más útiles para que encuentres lo que necesitas más rápido.',
  },
  resources: {
    title: 'Recursos populares',
    subtitle: 'Respuestas rápidas a las preguntas que más hacen los compradores antes de pedir.',
    reviews: { title: 'Reseñas de USFans', text: 'Comprende qué revisar antes de usar un servicio o vendedor.' },
    shipping: { title: 'Costo de envío de USFans', text: 'Aprende qué puede afectar los costos y tiempos de envío.' },
    coupons: { title: 'Cupones de USFans', text: 'Aprende a encontrar y verificar cupones y códigos de descuento disponibles.' },
    warehouse: { title: 'Almacén de USFans', text: 'Comprende el almacenamiento, la inspección y los procesos relacionados.' },
    legit: { title: '¿Es legítimo USFans?', text: 'Aprende controles prácticos de seguridad antes de comprar.' },
  },
  guide: {
    title: '¿Nuevo en USFans? Empieza aquí',
    text: 'Lee nuestra guía completa para principiantes para entender la hoja de cálculo, qué revisar antes de pedir y cómo evitar errores comunes.',
    cta: 'Leer la guía completa',
  },
  pillar: {
    title: 'Artículos y guías',
    subtitle: 'Guías detalladas sobre los temas que más importan antes de pedir.',
  },
  faq: {
    title: 'Preguntas frecuentes',
    q1: '¿Qué es una hoja de cálculo USFans?',
    a1: 'Una hoja de cálculo USFans es un catálogo organizado de enlaces de productos, categorías, datos de vendedores y recursos de compra. Te ayuda a explorar y comparar artículos en un solo lugar.',
    q2: '¿Cómo compro un producto que encontré en la hoja de cálculo?',
    a2: 'Sigue el enlace de la categoría al sitio principal, encuentra el artículo que quieres y completa el proceso de compra habitual allí.',
    q3: '¿La información de la hoja de cálculo siempre está actualizada?',
    a3: 'USFansLink mantiene la estructura y los enlaces organizados, pero la disponibilidad y los precios los gestiona el sitio principal. Verifica siempre los detalles allí antes de pedir.',
    q4: '¿USFansLink es lo mismo que el sitio principal?',
    a4: 'No. USFansLink es un recurso informativo independiente que te ayuda a explorar y entender la hoja de cálculo. Las compras se realizan en el sitio principal.',
  },
};